"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.infoCardValue = exports.infoCardHeader = exports.infoCardContainerStyle = void 0;
var typestyle_1 = require("typestyle");
require("@tableau/fonts-tableau");
var colors = require("../util/colors");
exports.infoCardContainerStyle = typestyle_1.style({
    display: 'flex',
    flexDirection: 'column',
});
var fontCommon = {
    fontWeight: 400,
    fontStyle: 'normal',
    color: colors.tableauGray11,
};
exports.infoCardHeader = typestyle_1.style(__assign(__assign({}, fontCommon), { fontSize: '18px', lineHeight: '27px', letterSpacing: '0.2px' }));
exports.infoCardValue = typestyle_1.style(__assign(__assign({}, fontCommon), { fontSize: '24px', lineHeight: '36px' }));
//# sourceMappingURL=InfoCardComponent.js.map